<script lang="js" setup>
import { ref, onMounted, Ref, computed } from "vue";
import { fetchGetApi, fetchPostApi } from "@/util/api";

const allData = ref([]);
const categories = ref([]);
const categorieNames = ref([]);
const departmentCategory = ref('');
import Swal from 'sweetalert2';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import { defineAsyncComponent } from 'vue';
import { Modal } from 'bootstrap';
import { is } from "date-fns/locale";

const modalCode = defineAsyncComponent(() => import("@/components/roles/modalCode.vue"));
const elementsPerPage = ref(25);
const currentPage = ref(1);
const filterQuery = ref("");
const toast = useToast();

const departmentName = ref('');
const departmentDescription = ref('');
onMounted(async () => {
    getData();
    getCategoryList();
});

function getData() {
    fetchGetApi('api/get/subcategory/all').then((response) => {
        console.log(response.data);
        if (response && response.data && response.data.length > 0) {
            const sites = response.data
            console.log(sites);
            allData.value = sites;
            console.log(allData.value);
        } else {
            toast.error('Failed to fetch data')
        }
    });
}
function getCategoryList() {
    fetchGetApi('api/category/get/all').then((response) => {
        console.log(response.data);
        if (response && response.data && response.data.length > 0) {
            const sites = response.data
            console.log(sites);
            categories.value = sites;
            categorieNames.value = sites.map((item) => item.name);
            console.log(categories.value);
        } else {
            toast.error('Failed to fetch data')
        }
    });
}

function getCategoryName(id) {
    const category = categories.value.find((item) => item._id === id);
    return category ? category.name : '';
}

// Add computed property for filtered data
const filteredData = computed(() => {
    const query = filterQuery.value.toLowerCase();
    if (!Array.isArray(allData.value)) return [];

    return allData.value.filter(item =>
        item.name.toLowerCase().includes(query) ||
        item.description.toLowerCase().includes(query) ||
        getCategoryName(item.CategoryId).toLowerCase().includes(query)
    );
});

// Add computed property for paginated data
const paginatedData = computed(() => {
    const startIndex = (currentPage.value - 1) * elementsPerPage.value;
    const endIndex = startIndex + elementsPerPage.value;
    return filteredData.value.slice(startIndex, endIndex);
});

function num_pages() {
    return Math.ceil(filteredData.value.length / elementsPerPage.value);
}

function change_page(page) {
    currentPage.value = page;
}

function previousPage() {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}

function nextPage() {
    if (currentPage.value < num_pages()) {
        currentPage.value++;
    }
}

function confirmDelete(id) {
    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
        if (result.isConfirmed) {
            deleteDepartment(id);
        }
    })
}
const isEditt = ref(false);
const dataa = ref({});

const modal = ref();
function showModal(isEdit = false, data = {}) {
    if (isEdit && data) {
        isEditt.value = true;
        dataa.value = data;
        departmentName.value = data.name;
        departmentDescription.value = data.description;
        categories.value.forEach((item) => {
            if (item._id === data.CategoryId) {
                departmentCategory.value = item.name;
            }
        });
    } else { isEditt.value = false; }
    modal.value = new Modal(document.getElementById('grid-modal'));
    modal.value.show();
}
function hideModal() {
    isEditt.value = false;
    dataa.value = {};
    departmentName.value = '';
    departmentDescription.value = '';
    departmentCategory.value = '';

    modal.value.hide();
}
function deleteDepartment(id) {
    fetchGetApi('api/delete/subcategory/' + id).then((response) => {
        console.log(response);
        toast.success(response.data['message']);
        getData();
    });
}
function formatDate(date) {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
}

function updateDepartment() {

    if (!departmentName.value) {
        toast.error('Department Name is required');
        return;
    }
    if (!departmentDescription.value) {
        toast.error('Department Description is required');
        return;
    }
    if (!departmentCategory.value) {
        toast.error('Department Category is required');
        return;
    }
    const data = {
        name: departmentName.value,
        description: departmentDescription.value,
        CategoryId: categories.value.find((item) => item.name === departmentCategory.value)._id
    }
    console.log(dataa.value);
    var url = isEditt.value ? 'api/edit/subcategory/' + dataa.value._id : 'api/add/subcategory';
    console.log(url);
    // return;
    fetchPostApi(url, data).then((response) => {
        console.log(response);
        toast.success(response.data['message']);
        hideModal();
        getData();
    });
}

</script>
<template>
    <Breadcrumbs main="Apps" title="Sub category" />
    <div class="container-fluid">
        <div class="email-wrap bookmark-wrap">
            <div class="row">
                <div class="table-responsive product-table custom-scrollbar">
                    <form class="no-footer">
                        <div class="mb-3 row justify-content-between align-items-center">
                            <div class="col-xs-3 col-sm-auto">
                                <label for="table-complete-search"
                                    class="col-xs-12 col-sm-auto col-form-label">Search:</label>
                                <input id="table-complete-search" type="text" class="form-control" name="searchTerm"
                                    v-model="filterQuery">
                            </div>
                            <div class="col-xs-3 col-sm-auto">
                                <button class="btn btn-primary" type="button" @click="showModal()">
                                    Add Sub Category
                                </button>
                            </div>
                        </div>
                        <table class="display table-striped table-hover table-bordered table" id="basic-1">
                            <thead>
                                <tr>
                                    <th class="sorting_asc" scope="col" style="width: 50px;">SL</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Name</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Category</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Description</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Created At</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Updated At</th>
                                    <th class="sorting_asc text-nowrap" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="!filteredData.length">
                                <tr class="odd">
                                    <td valign="top" colspan="7" class="dataTables_empty">No matching records found</td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(item, index) in paginatedData" :key="item._id">
                                    <td class="sorting_1" style="width: 10px;">{{ (currentPage - 1) * elementsPerPage +
                                        index + 1 }}</td>
                                    <td class="sorting_1">{{ item.name }}</td>
                                    <td class="sorting_1">{{ getCategoryName(item.CategoryId) }}</td>
                                    <td class="sorting_1">{{ item.description }}</td>
                                    <td class="sorting_1">{{ formatDate(item.createdAt) }}</td>
                                    <td class="sorting_1">{{ formatDate(item.updatedAt) }}</td>
                                    <td>
                                        <button class="btn btn-primary btn-xs me-2" type="button"
                                            data-original-title="Edit" @click="showModal(true, item)" title="">
                                            <i class="fas fa-edit"></i>
                                        </button>
                                        <button class="btn btn-danger btn-xs " type="button"
                                            data-original-title="Delete" @click='confirmDelete(item._id)' title="">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>
                </div>

                <ul class="pagination py-2 justify-content-end pagination-primary">
                    <li class="page-item" @click="previousPage">
                        <a class="page-link">Previous</a>
                    </li>
                    <li class="page-item" v-for="i in num_pages()" :key="i" :class="[i == currentPage ? 'active' : '']"
                        @click="change_page(i)">
                        <a class="page-link">{{ i }}</a>
                    </li>
                    <li class="page-item" @click="nextPage">
                        <a class="page-link">Next</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="modal fade" id="grid-modal" tabindex="-1" role="dialog" aria-labelledby="grid-modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Modal title</h5>
                    <button class="btn-close" type="button" @click="hideModal()" aria-label="Close"></button>
                </div>
                <div class="modal-body grid-showcase">
                    <div class="container-fluid bd-example-row">
                        <div class="row">
                            <!-- Form for Department Name and Description -->
                            <form class="col-md-12">
                                <div class="mb-3">
                                    <label for="department-name" class="form-label">Department Name</label>
                                    <input type="text" class="form-control" id="department-name"
                                        v-model="departmentName">
                                </div>
                                <div class="mb-3">
                                    <label for="department-description" class="form-label">Department
                                        Description</label>
                                    <textarea class="form-control" id="department-description" rows="3"
                                        v-model="departmentDescription"></textarea>
                                </div>
                                <!-- //add a dropdown to select category frrom categorieNames -->
                                <div class="mb-3">
                                    <label for="department-category" class="form-label">Select Category</label>
                                    <select class="form-select" id="department-category" v-model="departmentCategory">
                                        <option v-for="category in categorieNames" :key="category">{{ category }}
                                        </option>
                                    </select>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" type="button" data-bs-dismiss="modal">Close</button>
                    <button class="btn btn-primary" @click="updateDepartment()" type="button">Save</button>
                </div>
            </div>
        </div>
    </div>

</template>